<template>
	<button id="submitBtn" :type="status ? 'button' : 'submit'">
		<h2 v-if="!status">{{obj.title}}</h2>
		<h2 v-else :role="status ? 'status' : ''">{{obj.titlenext}}</h2>
	</button>
</template>

<script>

export default {
	name: 'submitButton',
	props: {
		obj: Object,
		status: Boolean
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
	color: #fff;
    background-color: #e40046;
    border: 0.125rem solid #e40046;
    height: auto;
    max-width: 24.5rem;
    line-height: 1.75rem;
    display: block;
	width: fit-content;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.75rem 1.375rem;
    box-shadow: 0 0.3125rem 0.25rem rgba(0, 0, 0, 0.06);
    border-radius: 0.25rem;
    position: relative;
    font-weight: bold;
    text-decoration: none;
    cursor: pointer;
    transition: .1s;
    text-align: left;
	margin: 0 auto;
}

button h2 {
	font-family: 'Nunito Sans', 'Helvetica', 'Arial', sans-serif;
	font-size: 1.125rem;
	line-height: 1.75rem;
	font-weight: bold;
    color: white;
}

button:hover {
	background-color: #cd003f;
    outline: 0;
}

button:focus {
	outline: 0;
}
button:focus-visible {
	outline-width: 0.25rem;
    outline-style: solid;
    outline-color: #ffd801;
    background-color: #ffd801;
    border-color: #252a36;
    color: #252a36;
    outline-offset: 0;
}
button:focus-visible h2 {
    color: #252a36;
}
h2, p {
	margin-top: 0;
	margin-bottom: 0;
}
p {
	padding-top: 0.25em;
	font-size: 1.125em;
}

@media screen and (max-width: 47.938rem) {
    button {
        width: 100%;
        text-align: center;
    }
}
</style>
